import * as React from "react";
import type { SVGProps } from "react";
const SvgBarChartSquareUp01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m6.5 14 4.2-4.2 3 3 3.6-3.6m-12.9 12A2.4 2.4 0 0 1 2 18.8V4.4A2.4 2.4 0 0 1 4.4 2h14.4a2.4 2.4 0 0 1 2.4 2.4v14.4a2.4 2.4 0 0 1-2.4 2.4z"
    />
  </svg>
);
export default SvgBarChartSquareUp01;
